import styled from "styled-components";

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  background: ${({ theme }) => theme.background};
  overflow: hidden;
`;

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  background: ${({ theme }) => theme.background};
  overflow: hidden;
`;

export const MenuSkeleton = styled.div`
  min-width: 15em;
  width: 15em;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: rgba(13, 15, 20, 0.9);
  border-right: 1px solid rgba(255, 255, 255, 0.03);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;

  .header {
    width: 100%;
    height: 4em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.03);

    .logo-full {
      width: 110px;
      height: auto;
      object-fit: contain;
      opacity: 0.95;
    }
  }

  .buttons {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow-y: auto;

    /* Scrollbar personalizada */
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 2px;
    }

    .menu-section {
      display: flex;
      flex-direction: column;
      margin-bottom: 0;
    }
  }

  .user-menu {
    width: 100%;
    padding: 1em;
    border-top: 1px solid rgba(255, 255, 255, 0.03);
    background: rgba(0, 0, 0, 0.2);
  }
`;

export const MainContent = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const HeaderSkeleton = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  background: ${({ theme }) => theme.card};
  border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const StatusBarSkeleton = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background: ${({ theme }) => theme.card};
  border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const ContentSkeleton = styled.div`
  flex: 1;
  width: 100%;
  padding: 0;
  overflow-y: auto;
  background: ${({ theme }) => theme.background};

  /* Scrollbar personalizada */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.border};
    border-radius: 6px;

    &:hover {
      background: ${({ theme }) => theme.text}40;
    }
  }
`;
